import pt from 'prop-types';
import React, { useContext, useEffect, useMemo } from 'react';
import { MicrocopyContext } from '../../../context/microcopy.context';
import { getCopy } from '../../../helpers/copy';
import { queryParamKeyMicrocopyKeyMap } from '../../../helpers/filters';
import { combine } from '../../../helpers/styles';
import FilterSet from '../filterSet';
import Icon from '../icon';
import Text from '../text';

import { AWARD_IDS } from '../../../utils/constants';
import FilterTag from '../filterTag';
import * as styles from './filtersModal.module.scss';

const FiltersModal = ({
  visibleFilters,
  activeFilters,
  buildSearchParamsAfterRemove,
  queryFilters,
  onClose,
  isOpen,
  filterOrderByKey,
  radioFiltersKeys,
  onFilterSetChange,
  applyLink,
  resetLink,
  type,
  year,
}) => {
  let orderedFiltersKeys = filterOrderByKey;
  if (orderedFiltersKeys.length === 0) {
    orderedFiltersKeys = Object.keys(visibleFilters);
  }
  const microcopy = useContext(MicrocopyContext);

  useEffect(() => {
    if (isOpen) {
      document.querySelector('body').style.height = '100vh';
    } else {
      document.querySelector('body').style.height = '';
    }
  }, [isOpen]);

  const renderFilters = useMemo(
    () =>
      visibleFilters
        ? orderedFiltersKeys
            .filter(
              (key) =>
                Array.isArray(visibleFilters[key]) && visibleFilters[key].length
            )
            .map((key) => (
              <FilterSet
                key={`mobile${key}`}
                label={key}
                visibleFilters={visibleFilters[key]}
                queryFilters={queryFilters[key]}
                isRadio={radioFiltersKeys?.includes(key)}
                openAtStart={true}
                type={type}
                year={year}
                // onChange={(val) => onFilterSetChange(key, val)}
              />
            ))
        : null,
    [visibleFilters, queryFilters]
  );

  return (
    <div className={combine(styles.container, isOpen && styles.open)}>
      <div className={styles.header}>
        <Text as="h2" type="h2" variant="semibold">
          {getCopy('results.filter', microcopy).toUpperCase()}
        </Text>
        <button className={styles.button} onClick={onClose}>
          <Icon name="times" className={styles.icon} />
        </button>
      </div>
      <div className={styles.filters}>
        {activeFilters
          .filter(
            (el) => !['categories', 'sort'].includes(el.key) && !el.locked
          )
          .map((filter) => {
            const searchParams = buildSearchParamsAfterRemove({
              key: filter.key,
              val: filter.id,
            }).toString();
            return (
              <FilterTag
                key={`${filter.key}-${filter.id}`}
                text={
                  queryParamKeyMicrocopyKeyMap[filter.key]
                    ? `filters.${queryParamKeyMicrocopyKeyMap[
                        filter.key
                      ]?.toLowerCase()}.${filter.id}`
                    : filter.label || filter.name
                }
                className={styles.filterTag}
                isLocked={filter.locked}
                isGolden={filter.id === AWARD_IDS.IFDA_GOLD}
                removeLink={`?${searchParams}`}
                filterKey={filter.key}
                filterId={filter.id}
                data-test={`filtertag-${filter.key}-${filter.id}`}
                type={type}
                year={year}
              />
            );
          })}
        {renderFilters}
      </div>
      {/* <div className={styles.actionButtons}>
        <a href={resetLink} className={styles.actionButton}>
          <Button
            className={styles.actionLink}
            type="secondary"
            text={`${getCopy('results.reset', microcopy)} (${Object.values(
              queryFilters
            ).reduce(
              (prev, curr) => prev + (Array.isArray(curr) ? curr.length : 0),
              0
            )})`}
          />
        </a>
        <a href={applyLink} className={styles.actionButton}>
          <Button
            className={styles.actionLink}
            type="primary"
            text={getCopy('results.apply', microcopy)}
          />
        </a>
      </div> */}
    </div>
  );
};

FiltersModal.propTypes = {
  visibleFilters: pt.object.isRequired,
  queryFilters: pt.object.isRequired,
  onFilterSetChange: pt.func,
  onClose: pt.func,
  isOpen: pt.bool,
  hideSort: pt.bool,
  filterOrderByKey: pt.array,
  applyLink: pt.string,
  resetLink: pt.string,
  type: pt.string,
};

FiltersModal.defaultProps = {
  visibleFilters: {},
  queryFilters: {},
  onFilterSetChange: () => {},
  onClose: () => {},
  isOpen: false,
  filterOrderByKey: [],
  type: '',
};

export default FiltersModal;
